import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

@Component({
  selector: 'fl-annotation-indicator',
  template: ` <div class="Indicator"></div> `,
  styleUrls: ['./annotation-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnotationIndicatorComponent {
  @HostBinding('attr.data-animating')
  @Input()
  isAnimating = true;
}
